var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiners = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.045,
    height: 21.461,
    viewBox: "0 0 30.045 21.461",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cfd8dc;}.b{fill:#1565c0;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.045,27.6a2.87,2.87,0,0,1-2.861,2.861H5.861A2.87,2.87,0,0,1,3,27.6V11.861A2.87,2.87,0,0,1,5.861,9H30.184a2.87,2.87,0,0,1,2.861,2.861Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.876,16H16.723a5.723,5.723,0,1,0,0,11.446h7.154a5.723,5.723,0,1,0,0-11.446Z",
    transform: "translate(-2.277 -1.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.292,18a4.292,4.292,0,1,0,4.292,4.292A4.3,4.3,0,0,0,17.292,18Zm-2.861,4.292a2.918,2.918,0,0,1,2.146-2.79V25.01A2.772,2.772,0,0,1,14.431,22.292Zm3.577,2.79V19.574a2.854,2.854,0,0,1,2.146,2.79A2.9,2.9,0,0,1,18.007,25.082Z",
    transform: "translate(-2.846 -2.562)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiners);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diners.6f2fd91314bfdb0d298af5d47e056a34.svg";